import script from "./NoticeView.vue?vue&type=script&setup=true&lang=ts"
export * from "./NoticeView.vue?vue&type=script&setup=true&lang=ts"

import "./NoticeView.vue?vue&type=style&index=0&id=a4753142&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4753142"]])

export default __exports__